import { HorizontalSliderForm } from "./horizontal-slider-form";
import { HorizontalSliderHandler } from "./horizontal-slider-handler";
import { HorizontalSliderListener } from "./horizontal-slider-listener";

export class HorizontalSliderSetup {
    private readonly root: HTMLElement;

    private readonly form: HorizontalSliderForm;

    private readonly handler: HorizontalSliderHandler;

    private readonly listener: HorizontalSliderListener;

    public constructor(root: HTMLElement) {
        this.root = root;
        this.form = new HorizontalSliderForm(root);
        this.handler = new HorizontalSliderHandler(this.form);
        this.listener = new HorizontalSliderListener(this.form, this.handler);
    }

    public init(): void {
        if (!(this.root instanceof HTMLElement)) return;
        if (this.form.isInitialized()) return;

        this.form.markInitialized();
        this.listener.register();
        this.handler.bootstrap();
    }

    public static init(rootEl?: ParentNode | Document | HTMLElement): void {
        const root = rootEl || document;
        if (!(root instanceof Document || root instanceof HTMLElement)) return;

        HorizontalSliderForm.getRoots(root).forEach((slider) => {
            const instance = new HorizontalSliderSetup(slider);
            instance.init();
        });
    }
}
